import React, { Component } from 'react'
import { Creatable } from 'react-select'
import { connect } from 'react-redux'

import Button from './Button'
import Checkbox from './Checkbox'
import FloatingPlaceholderGroup from './FloatingPlaceholderGroup'

import { closeModal } from '../../reducers/modal'

import { apiFetch } from '../../utils/api'
import { postEmailToMailchimpAndSheets } from '../../utils/email'
import { trackEvent } from '../../utils/tracking'

import { emailCollectionConfigs } from '../../config/email'
import { CONSOLE_BASE_URL } from '../../config/'

// const ENTERPRISE_CONTACT_REQUEST_ENDPOINT = 'http://localhost:4000/api/enterprise-request'
const ENTERPRISE_CONTACT_REQUEST_ENDPOINT = `${CONSOLE_BASE_URL}/api/enterprise-request`

const SDK_PLATFORMS = [
  { label: 'Raspberry', value: 'raspberrypi' },
  { label: 'Linux', value: 'linux' },
  { label: 'macOS', value: 'macOS' },
  { label: 'Windows', value: 'windows' },
  { label: 'android', value: 'android' }
]

const DOMAINS_LIST = [
  { label: 'Banking', value: 'Banking' },
  { label: 'Car Manufacturer', value: 'Car Manufacturer' },
  { label: 'Car Infotainment', value: 'Car Infotainment' },
  { label: 'Cloud Platform', value: 'Cloud Platform' },
  { label: 'Connected Speaker', value: 'Connected Speaker' },
  { label: 'Consulting', value: 'Consulting' },
  { label: 'Consumer Electronics', value: 'Consumer Electronics' },
  { label: 'Drones & Robots', value: 'Drones & Robots' },
  { label: 'Elderly Solutions', value: 'Elderly Solutions' },
  { label: 'Electronic Equipment', value: 'Electronic Equipment' },
  { label: 'Elevator Manufacturer', value: 'Elevator Manufacturer' },
  { label: 'Energy', value: 'Energy' },
  { label: 'Gym Equipment Manufacturer', value: 'Gym Equipment Manufacturer' },
  { label: 'Healthcare Robots', value: 'Healthcare Robots' },
  { label: 'Home Appliance', value: 'Home Appliance' },
  { label: 'Home Robots', value: 'Home Robots' },
  { label: 'Home Security', value: 'Home Security' },
  { label: 'IC/Chip Maker', value: 'IC/Chip Maker' },
  { label: 'Insurance', value: 'Insurance' },
  { label: 'Luxury', value: 'Luxury' },
  { label: 'Medical Solutions', value: 'Medical Solutions' },
  { label: 'OEM', value: 'OEM' },
  { label: 'Proto Boards', value: 'Proto Boards' },
  { label: 'Real Estate', value: 'Real Estate' },
  { label: 'Retailers', value: 'Retailers' },
  { label: 'Routers', value: 'Routers' },
  { label: 'Smart Home Hubs', value: 'Smart Home Hubs' },
  { label: 'Telecom', value: 'Telecom' },
  { label: 'Toy Manufacturer', value: 'Toy Manufacturer' },
  { label: 'Toy Programming', value: 'Toy Programming' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Other', value: 'Other' }
]

class EnterpriseContactModal extends Component {
  constructor () {
    super()
    this.state = {
      sending: false,
      success: false,
      error: false,
      platformsSelected: [],
      domainsSelected: [],
      optedInToNewsletter: false
    }
    this.handleSubmitForm = this.handleSubmitForm.bind(this)
  }

  handleSubmitForm (e) {
    e.preventDefault()
    const {
      domainsSelected,
      platformsSelected,
      optedInToNewsletter
    } = this.state
    const formData = {
      firstname: this.firstnameInput.value,
      lastname: this.lastnameInput.value,
      company: this.companyInput.value,
      email: this.emailInput.value,
      phone: this.phoneInput.value,
      usecase: this.usecaseInput.value, // use_case
      deadline: this.deadlineInput.value,
      nrUnits: this.nrUnitsInput.value, // number_units
      domains: domainsSelected, // domain
      platforms: platformsSelected, // platform
      newsletterSignup: optedInToNewsletter // newsletter_signup
    }
    this.setState({ sending: true })
    if (optedInToNewsletter) {
      postEmailToMailchimpAndSheets(
        this.emailInput.value,
        emailCollectionConfigs.newsletter
      )
    }

    apiFetch(ENTERPRISE_CONTACT_REQUEST_ENDPOINT, {
      method: 'post',
      body: JSON.stringify(formData)
    })
      .then(json => {
        const allPostsFailed =
          typeof json.success !== 'object' ||
          !Object.values(json.success).some(Boolean)
        this.setState({
          sending: false,
          success: !allPostsFailed,
          error: allPostsFailed
        })
      })
      .catch(e => {
        console.log('error posting enterprise contact request', e)
        this.setState({ sending: false, success: false, error: true })
      })
    trackEvent('EnterpriseContactModalSubmit')
  }

  render () {
    const {
      sending,
      success,
      error,
      platformsSelected,
      domainsSelected,
      optedInToNewsletter
    } = this.state

    if (success) {
      return (
        <div className='enterprise-contact-modal center'>
          <header>
            <h3 className='h3 mb1'>Great! You’ll hear from us soon!</h3>
          </header>
        </div>
      )
    }
    return (
      <div className='enterprise-contact-modal p2 center clearfix'>
        <header className='enterprise-contact-modal__header'>
          <h3 className='h3 mb1'>Contact our Enterprise team</h3>
          <p className='grey'>
            Let’s discuss how Snips can accomodate your needs and your platform
          </p>
        </header>

        <form
          className='enterprise-contact-modal__form'
          onSubmit={e => {
            this.handleSubmitForm(e)
          }}
        >
          <div>
            <div className='col col-12 md-col-4 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='firstname'
                label='First Name'
                inputType='text'
                required
                refFn={c => {
                  if (c) {
                    this.firstnameInput = c
                  }
                }}
              />
            </div>

            <div className='col col-12 md-col-4 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='lastname'
                label='Last Name'
                inputType='text'
                required
                refFn={c => {
                  if (c) {
                    this.lastnameInput = c
                  }
                }}
              />
            </div>

            <div className='col col-12 md-col-4 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='company'
                label='Company'
                inputType='text'
                required
                refFn={c => {
                  if (c) {
                    this.companyInput = c
                  }
                }}
              />
            </div>
          </div>

          <div>
            <div className='col col-12 md-col-6 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='email'
                label='Email'
                inputType='email'
                required
                refFn={c => {
                  if (c) {
                    this.emailInput = c
                  }
                }}
              />
            </div>

            <div className='col col-12 md-col-6 pr2 mb2 left-align'>
              <FloatingPlaceholderGroup
                inputName='phone'
                label='Phone (including country code)'
                inputType='text'
                refFn={c => {
                  if (c) {
                    this.phoneInput = c
                  }
                }}
              />
              <span className='grey enterprise-contact-modal__field-subtitle'>
                e.g. +1 (234) 567-8910 or +33 6 12 34 56 78
              </span>
            </div>
          </div>

          <div>
            <div className='col col-12 md-col-12 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='targeted-usecases'
                label='Describe your use case(s)'
                inputType='text'
                refFn={c => {
                  if (c) {
                    this.usecaseInput = c
                  }
                }}
              />
            </div>
          </div>

          <div>
            <div className='col col-12 md-col-6 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='deadline'
                label='Deadline for project'
                inputType='text'
                required
                refFn={c => {
                  if (c) {
                    this.deadlineInput = c
                  }
                }}
              />
            </div>

            <div className='col col-12 md-col-6 pr2 mb2'>
              <FloatingPlaceholderGroup
                inputName='nrUnits'
                label='Expected number units to be run on'
                inputType='text'
                required
                refFn={c => {
                  if (c) {
                    this.nrUnitsInput = c
                  }
                }}
              />
            </div>
          </div>

          <div className='mb1'>
            <div className='col col-12 md-col-6 pr2 mb2'>
              <label className='left-align'>
                <div>What platform(s) are you interested in?</div>
                <Creatable
                  multi
                  placeholder='Select or type other...'
                  promptTextCreator={label => `Add custom platform: ${label}`}
                  simpleValue
                  clearable={false}
                  name='platforms'
                  value={platformsSelected}
                  onInputKeyDown={event => {
                    if (event.keyCode === 9) event.preventDefault()
                  }}
                  onChange={value => {
                    this.setState({ platformsSelected: value.split(',') })
                  }}
                  options={SDK_PLATFORMS}
                />
              </label>
            </div>
            <div className='col col-12 md-col-6 pr2 mb2'>
              <label className='left-align'>
                <div>What domain(s) are you interested in?</div>
                <Creatable
                  multi
                  placeholder='Select or type other...'
                  promptTextCreator={label => `Select a domain: ${label}`}
                  simpleValue
                  clearable={false}
                  name='domains'
                  value={domainsSelected}
                  onInputKeyDown={event => {
                    if (event.keyCode === 9) event.preventDefault()
                  }}
                  onChange={value => {
                    this.setState({ domainsSelected: value.split(',') })
                  }}
                  options={DOMAINS_LIST}
                  required
                />
              </label>
            </div>
          </div>

          <div className='mb3'>
            <div className='col col-12 md-col-12 pr2 mb2'>
              <Checkbox
                checked={optedInToNewsletter}
                label={
                  <span className='ml1'>
                    Subscribe to hear about our latest products, releases,
                    events, and news.
                  </span>
                }
                onChange={() =>
                  this.setState({ optedInToNewsletter: !optedInToNewsletter })}
              />
            </div>
          </div>

          <div className='center'>
            {error && (
              <p className='mb2'>⚠️ Something went wrong, please try again.</p>
            )}
            <Button
              type='submit'
              className='button button--primary button--large'
            >
              {sending ? <span>Submitting&hellip;</span> : 'Submit'}
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

export default connect(null, {
  closeModal
})(EnterpriseContactModal)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/EnterpriseContactModal.js